"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const permissions_1 = __importDefault(require("../permissions"));
class Role {
    constructor(id, name, isInternalRole, priority, legacyId, description, permissions) {
        this.id = id;
        this.name = name;
        this.isInternalRole = isInternalRole;
        this.priority = priority;
        this.legacyId = legacyId;
        this.description = description;
        this.getVisibleRoleId = () => {
            if (this.isInternalRole) {
                return this.name;
            }
            return this.id;
        };
        this.permissions = permissions;
    }
    static fromObj(data) {
        const permissions = data.permissions
            ? data.permissions.map((perm) => permissions_1.default.fromObj(perm))
            : [];
        return new Role(data.id, data.name, data.isInternalRole, data.priority, data.legacyId, data.description, permissions);
    }
}
exports.default = Role;
Role.getHighLevelRolePriority = (userRoleIds, allRoles) => {
    const userRoles = allRoles.filter((role) => userRoleIds.includes(role.id));
    return userRoles.reduce((prev, curr) => prev.priority < curr.priority ? prev : curr);
};
Role.getRolesUnderPriority = (priority, allRoles) => allRoles.filter((role) => role.priority >= priority);
Role.hasPermissions = (userPermissions, permissionsToCheck) => {
    if (!permissionsToCheck)
        return true;
    const hasPermission = permissionsToCheck === null || permissionsToCheck === void 0 ? void 0 : permissionsToCheck.some((p) => userPermissions.includes(p));
    return hasPermission || false;
};
//# sourceMappingURL=role.class.js.map